<template>
    <div class="price-sheet-multipliers">
        <!-- Account Selector -->
        <div class="select-account" v-if="customerAccounts.length">
            <h4>Choose Your Account</h4>
            <div class="select">
                <select v-model="selectedAccountId">
                    <option :value="null">Choose one</option>
                    <template v-for="account in customerAccounts">
                        <option :value="account.id">{{ account.name }} [account number: {{ account.id }}]</option>
                    </template>
                </select>
            </div>
        </div>

        <!-- Multipliers Table -->
        <div v-if="selectedAccountId && !loading && Object.keys(multipliers).length" class="price-sheet-table">
            <table class="data fullwidth">
                <thead>
                    <tr>
                        <th>Product Price Sheet</th>
                        <th>Component</th>
                        <th>Sheet Name</th>
                        <th>Multiplier</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(multiplier, sheetName) in multipliers" :key="sheetName">
                        <td>{{ multiplier.productPriceSheet }}</td>
                        <td>{{ multiplier.component }}</td>
                        <td>{{ sheetName }}</td>
                        <td>{{ formatMultiplier(multiplier.value) }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="info">
                <p>
                    New price is effective July 21, 2025.
                </p>
            </div>
        </div>

        <div v-if="selectedAccountId && !loading && !Object.keys(multipliers).length" class="no-results">
            Please contact your local ASC Sales Representative for pricing.
        </div>

        <div v-if="loading" class="loading">
            Loading...
        </div>

        <div v-if="error" class="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customerAccounts: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            selectedAccountId: null,
            multipliers: {},
            loading: false,
            error: null
        }
    },

    watch: {
        selectedAccountId(newId) {
            if (newId) {
                this.fetchMultipliers(newId);
            } else {
                this.multipliers = {};
                this.error = null;
            }
        }
    },

    methods: {
        async fetchMultipliers(accountId) {
            this.loading = true;
            this.error = null;

            try {
                const response = await fetch(`/actions/anvil-module/price-sheet-multipliers/get-multipliers?accountId=${accountId}`);
                const data = await response.json();

                if (data.error) {
                    this.error = data.error;
                    this.multipliers = {};
                } else {
                    this.multipliers = data;
                }
            } catch (error) {
                this.error = 'Error fetching multipliers: ' + error.message;
                this.multipliers = {};
            } finally {
                this.loading = false;
            }
        },

        formatMultiplier(value) {
            return Number(value).toFixed(3);
        }
    }
}
</script>

<style>
.price-sheet-multipliers {
    margin-top: 2rem;
}

.select-account {
    margin-bottom: 2rem;
}

.price-sheet-table {
    margin-top: 1rem;
}

.loading {
    text-align: center;
    padding: 2rem;
}

.error {
    color: red;
    margin: 1rem 0;
}
</style>